<div
  class="content"
  [class.fullscreen]="tabBarComponent.hideTabBar()"
  [@routeAnimations]="outlet?.activatedRouteData?.['animation']"
>
  <div
    class="clickable-media"
    [dwallClickableMedia]="['/main', 'special-offer']"
  ></div>

  <core-background-player
    class="background-player"
  />

  <router-outlet #outlet="outlet"/>
</div>

<app-tab-bar #tabBarComponent/>

@if (idleNavigation.showWakeSurface()) {
  <button
    type="button"
    class="idle-wake"
    aria-label="Open start page"
    [attr.aria-busy]="idleNavigation.waking()"
    (touchstart)="onWakeTouch($event)"
    (touchcancel)="onWakeTouch($event)"
    (click)="onWakeClick($event)"
  >
    @if (idleNavigation.wakeUnavailable()) {
      <span class="unavailable" role="status">The start page is unavailable.</span>
    }
  </button>

  <app-interaction-prompt class="idle-interaction-prompt" aria-hidden="true"/>
}
